import { formatLocation, getSalary } from "@/helpers/jobs";
import {
  BriefCase,
  CurrencyIcon,
  Industry,
  Location,
  WalletSalary,
} from "@monsterindia/global-ui-components";
import React, { useMemo } from "react";

import { getTextWithIcon } from "@/components/single-page-registration/job-detail/common";

const JobHighlight = ({ jobData, isMobile, siteContext }: any) => {
  const jobExperience = useMemo(() => {
    const years = jobData.maximumExperience?.years;
    return Boolean(years && years < 50);
  }, [jobData.maximumExperience?.years]);

  const jobSalary = useMemo(() => {
    const { hideSalary, minimumSalary, maximumSalary } = jobData;
    return Boolean(
      hideSalary !== 1 &&
        minimumSalary?.absoluteValue &&
        maximumSalary?.absoluteValue,
    );
  }, [jobData]);

  const jobExpValue = useMemo(() => {
    const { minimumExperience, maximumExperience } = jobData;
    return maximumExperience?.years
      ? `${minimumExperience?.years || 0}-${maximumExperience.years} Years`
      : "Fresher";
  }, [jobData]);

  const locations = formatLocation(jobData.locations);

  const industries = useMemo(
    () =>
      Array.isArray(jobData.industries) ? jobData.industries.join(", ") : "",
    [jobData.industries],
  );

  const isIndianCurrency = () => jobData?.minimumSalary?.currency === "INR";

  const renderJobSalary = () => {
    if (jobData.jobSalaryConfidential) {
      return getTextWithIcon(
        "Confidential",
        <WalletSalary width={16} height={16} fill="#59566C" />,
      );
    }

    return isIndianCurrency()
      ? getTextWithIcon(
          getSalary(jobData, "rexmonster"),
          <CurrencyIcon
            siteContext="rexmonster"
            fill="#59566C"
            width={16}
            height={16}
          />,
          jobData.hideSalary,
          "",
          !isMobile,
        )
      : getTextWithIcon(
          getSalary(jobData, siteContext),
          <WalletSalary width={16} height={16} fill="#59566C" />,
          jobData.hideSalary,
          "",
          !isMobile,
        );
  };

  return (
    <div className="flex flex-col gap-3 px-4 md:!gap-4 md:!px-6">
      {(jobExperience || jobSalary) && (
        <div className="text-content-primary flex gap-4 text-sm font-normal md:!max-h-5">
          {jobExperience &&
            getTextWithIcon(
              `Exp: ${jobExpValue}`,
              <BriefCase width={16} height={16} fill="#59566C" />,
            )}
        </div>
      )}
      {!isMobile && jobSalary && <div>{renderJobSalary()}</div>}
      {locations && (
        <div className="text-content-primary flex gap-4 text-sm font-normal">
          {getTextWithIcon(
            locations,
            <Location width={16} height={16} fill="#59566C" />,
            jobData.hideSalary,
            "location",
          )}
        </div>
      )}

      {industries && industries !== "Other" && (
        <div className="text-content-primary flex gap-4 text-sm font-normal">
          {getTextWithIcon(
            industries,
            <Industry width={16} height={16} fill="#59566C" />,
            jobData.hideSalary,
            "industry",
          )}
        </div>
      )}
    </div>
  );
};

export default JobHighlight;
